import type { PickerProps } from 'emoji-mart';
import React, { lazy, Suspense } from 'react';
import styles from './EmojiPickerDropdown.module.scss';

export type { BaseEmoji, EmojiData } from 'emoji-mart';

const Picker = lazy(() => import('emoji-mart/dist-es/components/picker/picker'));

const EmojiPicker: React.FC<PickerProps> = props => {
  return (
    <Suspense fallback={<div className={styles.loading}>Loading...</div>}>
      <Picker {...props} />
    </Suspense>
  );
};

export default EmojiPicker;
